import { MainMenu, StrongText, Text, VideoConsultationIcon } from '@dreryk/react-components';
import { Translate } from '@dreryk/react-common';

import { useVideoConsultationGlobalState } from './shared/useVideoConsultationGlobalState';
import { translationKeys } from './translations';

export const VideoConsultationMainMenuTileItem = (): JSX.Element | null => {
   const { state, showWindow } = useVideoConsultationGlobalState();

   if (state.type === 'idle') {
      return null;
   }

   if (!state.window.minimized) {
      return null;
   }

   return (
      <MainMenu.TileItem testId={'videoConsultation'} icon={<VideoConsultationIcon />} onClick={showWindow} pulse>
         <StrongText testId={'participantName'} maxLines={1}>
            {state.participantName}
         </StrongText>
         <Text testId={'status'}>
            <Translate>{translationKeys.pending}</Translate>
         </Text>
      </MainMenu.TileItem>
   );
};
